import $ from "jquery"


# =============================================================================
# > SLIDERS
# =============================================================================
import "slick-carousel" # @see https://github.com/kenwheeler/slick/
import "./../tools/lightSlide.coffee"

$ ->
    $("#hp-intro .slide").lightSlide()

    # ========== HOME NEWS ========== #
    $("#hp-news .news-feed").slick
        appendArrows: $("#hp-news .news-feed").next("nav")
        infinite: false
        variableWidth: true
        centerMode: true
        # slidesToShow: 2

    # ========== PEOPLE ARCHIVE ========== #
    # $(".archive-people").slick
    #     initialSlide: 3
    #     variableWidth: true
    #     centerMode: true
    #     slidesToShow: 3
    #     appendArrows: $(".archive-people__nav")
    #     # autoplay: true
    #     autoplaySpeed: 5000

    # ========== TESTIMONIES ========== #
    $(".archive-testimonies")
    .on "init", ->
        $(window).resize()
    .slick
        appendArrows: $(".archive-testimonies").parent(".container").next("nav")
        fade: true
        speed: 1000
        # draggable: false


    # ========== STANDALONE ========== #
    $(".images-slides-standalone__main").first().slick
        asNavFor: ".images-slides-standalone__nav"
        variableWidth: true
        centerMode: true
        focusOnSelect: true
        arrows: false
        infinite: false


    $(".images-slides-standalone__nav").each ->
        $(@).slick
            centerMode: true
            focusOnSelect: true
            asNavFor: ".images-slides-standalone__main"
            variableWidth: true
            infinite: false

    # ========== PRINT ========== #
    $(".action-print").click -> window.print()


# =============================================================================
# > MAPS
# =============================================================================
import "./../tools/gmap.coffee"

$ ->
    $fwMap = $(".full-width-map").gmap()
    if $fwMap then $fwMap.center(false, 15)
    $(".map-standalone").gmap()

# =============================================================================
# > COLLAPSABLES
# =============================================================================
import "./../tools/collapsable.coffee"

$ -> $(".prop-list").collapsable()
$ -> $(".collapsable").collapsable()

# =============================================================================
# > SHAVE
# =============================================================================
import shave from "shave"

shave ".news-feed__item .excerpt", 100



// WEBPACK FOOTER //
// ./scripts/modules/contents.coffee